import ApplicationController from '../application-controller';

export default class extends ApplicationController {
  declare observer?: IntersectionObserver;

  static targets = ['template', 'video'];

  declare readonly hasTemplateTarget: boolean;
  declare readonly templateTarget: HTMLTemplateElement;
  declare readonly templateTargets: HTMLTemplateElement[];

  declare readonly hasVideoTarget: boolean;
  declare readonly videoTarget: HTMLVideoElement;
  declare readonly videoTargets: HTMLVideoElement[];

  connect() {
    super.connect();
    this.setupObserver();
  }

  setupObserver() {
    this.observer = new IntersectionObserver(this.onObserverCallback, {});
    this.observer.observe(this.element);
  }

  onObserverCallback: IntersectionObserverCallback = (entries) => {
    if (entries.some((entry) => entry.isIntersecting)) {
      this.enter();
    } else {
      this.exit();
    }
  };

  enter() {
    this.data.set('video-displayed', '');

    if (this.hasTemplateTarget) {
      const video = this.templateTarget.content.cloneNode(true);

      this.element.appendChild(video);
    }
  }

  exit() {
    this.data.delete('video-displayed');

    this.videoTargets.forEach((video) => video.remove());
  }
}
